/* eslint-disable max-len */
import React, {useState} from 'react';
import './styles.scss';

const ErrorIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="#F67A7A" className="bi bi-x-circle-fill prices-validation__item_icon" viewBox="0 0 16 16">
  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z"/>
</svg>;

const AdditionalErrors = ({additionalData, errorsDatesRanges}) => {
  const [showInfo, setShowInfo] = useState(false);
  const toggleSize = () => {
    setShowInfo((showInf) => !showInf);
  };

  return (
    <div
      class={`prices-validation__box-errors-container ${showInfo ? 'prices-validation__box-errors-enlarged' : ''}`}
      onClick={toggleSize}
    >
      {!showInfo ?
        <div className='prices-validation__box-errors-first'>
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="#F67A7A" className="bi bi-x-circle-fill" viewBox="0 0 16 16">
            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z"/>
          </svg>
          <div className='prices-validation__texts'>
            <span>+{Object.keys(additionalData || {}).length + Object.keys(errorsDatesRanges || {}).length} errores</span>
            <span className='prices-validation__p'>pulsa para ver más</span>
          </div>
        </div> :
        <div className='prices-validation__box-errors-second'>
          {
            errorsDatesRanges &&
              <>
                <span>Se han encontrado vigencias de producción solapadas o no continuas en los siguientes modelos:</span>
                {
                  Object.keys(errorsDatesRanges).map((model) => <div className='prices-validation__item'><ErrorIcon /> {model}</div>)
                }
              </>
          }

          {
            additionalData &&
              <>
                <span>Faltan precios para los siguentes modelos:</span>
                {
                  Object.keys(additionalData).map((model) => {
                    return (
                      <div>
                        <span className='prices-validation__title'>- {model}</span>
                        <div>
                          {
                            (additionalData[model] || []).map((vehicle) => (
                              <div className='prices-validation__item'>
                                <ErrorIcon />
                                <div>{`${vehicle.outdoorColor} ${vehicle.outdoorColorDesc} - ${vehicle.indoorColor} ${vehicle.indoorColorDesc}`}</div>
                              </div>
                            ))
                          }
                        </div>
                      </div>
                    );
                  })
                }
              </>
          }
        </div>
      }
    </div>
  );
};

export default AdditionalErrors;
